import { Col, Form, FormControl, FormGroup, Row } from "react-bootstrap";

import { useTranslateContext } from "../../contexts/translate.context";

import { toUpperCase } from "../../utilities/auxiliary-functions";
import ImageLightBox from "../../components/image-lightbox/ImageLightbox";
import styles from './vehicle.record.module.scss'
import { Tooltip as TooltipMaterial } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { CameraAltOutlined } from "@mui/icons-material";

export interface IVehicleRecordProps {
    title: any,
    isEdit: boolean,
    identifier: boolean,
    viewOnly?: boolean,
    isViewAddress: boolean,

    created?: any,
    updated?: any,    
    plate: any,
    mark: any,
    colorName: any,
    model: any,
    manufacture: any,
    setPlate: any,
    setMark: any,
    setColorName: any,
    setModel: any,
    setManufacture: any,

    image?:any,
    changeImage?: any
}

export const VehicleRecord: React.FC<IVehicleRecordProps> = (props: IVehicleRecordProps) => {

    const { display } = useTranslateContext();

    return (
        <>
            <Row>
                <fieldset>
                    <legend>{display.legend.general_data}</legend>
                    <Row>
                        <Col sm="5">
                            {props.image ? (
                                <div
                                    className='d-flex flex-column justify-content-center align-items-center'>
                                    <ImageLightBox containerStyle={`${styles.imageWrapper}
                                        ${styles.vesselImage} mb-3`} src={props.image}
                                        alt={'Veículo'}/>
                                    {!props.viewOnly && <FormGroup as={Row} className={`d-flex
                                        justify-content-center ${styles.imageControls}`}>
                                        <label htmlFor={`member-image`}>
                                            <TooltipMaterial className="isClickable"
                                                title="Fazer upload de nova foto">
                                                <CloudUploadIcon />
                                            </TooltipMaterial>
                                        </label>
                                        <label className="text-right">
                                            <TooltipMaterial className="isClickable ms-2"
                                                title="Remover foto atual">
                                                <HighlightOffIcon />
                                            </TooltipMaterial>
                                        </label>
                                        <Form.Control type='file'
                                            id={`member-image`}
                                            accept="image/*"
                                            onChange={(e)=> props.changeImage(e) } />
                                    </FormGroup>}
                                </div>
                            ) : (
                                <div className={`${styles.imageWrapper}
                                    ${styles.vesselImagePlaceholder}`}>
                                    <CameraAltOutlined color='secondary' className={`isClickable
                                        ${styles.svg}`} sx={{fontSize: '73px'}} />
                                    {!props.viewOnly && <FormGroup as={Row} className={` d-flex
                                        justify-content-center ${styles.imageControls}`}>
                                        <label htmlFor={`member-image-placeholder`}>
                                            <TooltipMaterial className="isClickable"
                                                title="Fazer upload de nova foto">
                                                <CloudUploadIcon />
                                            </TooltipMaterial>
                                        </label>
                                        <label className="text-right">
                                            <TooltipMaterial className="isClickable ms-2"
                                                title="Remover foto atual">
                                                <HighlightOffIcon />
                                            </TooltipMaterial>
                                        </label>
                                        <Form.Control type='file'
                                            id={`member-image-placeholder`}
                                            accept="image/*" onChange={(e)=> props.changeImage(e) } />
                                    </FormGroup>}
                                </div>
                            )}
                        </Col>
                        <Col sm="7">
                            <Row>
                                <Col sm="4">
                                    <FormGroup>
                                        <Form.Label htmlFor="form-plate">{display.label.plate}</Form.Label>
                                        <FormControl id="form-plate" name="plate" placeholder={display.example.plate}
                                            disabled={!props.isEdit}
                                            value={props.plate}
                                            onChange={e => props.setPlate(toUpperCase(e.target.value))}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm="5"></Col>
                                <Col sm="3">
                                    <FormGroup>
                                        <Form.Label htmlFor="form-manufacture">{display.label.year}</Form.Label>
                                        <FormControl id="form-manufacture" name="manufacture" placeholder={display.example.manufacture}
                                            disabled={!props.isEdit}
                                            value={props.manufacture}
                                            onChange={e => props.setManufacture(e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="6">
                                    <FormGroup>
                                        <Form.Label htmlFor="form-mark">{display.label.mark}</Form.Label>
                                        <FormControl id="form-mark" name="mark" placeholder={display.example.mark}
                                            disabled={!props.isEdit}
                                            value={props.mark}
                                            onChange={e => props.setMark(e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm="6">
                                    <FormGroup>
                                        <Form.Label htmlFor="form-model">{display.label.model}</Form.Label>
                                        <FormControl id="form-model" name="model" placeholder={display.example.model}
                                            disabled={!props.isEdit}
                                            value={props.model}
                                            onChange={e => props.setModel(e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <FormGroup>
                                        <Form.Label htmlFor="form-color-name">{display.label.color_name}</Form.Label>
                                        <FormControl id="form-color-name" name="colorName" placeholder={display.example.color_name}
                                            disabled={!props.isEdit}
                                            value={props.colorName}
                                            onChange={e => props.setColorName(e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </fieldset>
            </Row>
        </>
    );

}

export default VehicleRecord;
